export default __webpack_public_path__ + "static/media/search--white.2b66fb48aef152755649d41e07a8f1dc.svg";